import { useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import styled from 'styled-components';
import { ThemeButton } from '../../theme/components/Button';
import { ThemeCard } from '../../theme/components/Card';
import ThemeContainer from '../../theme/components/Container';
import { ThemeHeadline } from '../../theme/components/Headline';
import { ThemeInput } from '../../theme/components/Input';
import { theme } from '../../theme/theme';

export interface StepContainerItem1Props {
  onNextClicked: (productInformation: string) => void;
}

export const StepContainerItem1: React.FC<StepContainerItem1Props> = ({ onNextClicked }) => {
  const [productInformation, setProductInformation] = useState<string>('');

  const handleNextClicked = () => {
    onNextClicked(productInformation);
  };

  return (
    <Container>
      <ThemeHeadline variant='h3' title='Feature-Priorisierung ist kompliziert? Nicht mit diesem Tool!' />
      <ThemeHeadline title='Die Priorisierung von Features ist ein aufwändiges und kompliziertes unterfangen. Mit dem Kano-Modell gelingt es, die unterschiedlichen Feature-Ideen verschiedenen Kategorien zuzuordnen und daraus Prioritäten abzuleiten. Nutze unsere kostenlose Feature-Priorisierung nach dem Kano-Modell.' />

      <Card>
        <ThemeHeadline variant='h3' title='Schritt 1: Dein Produkt' />
        <ThemeHeadline title='Um was für ein Produkt handelt es sich?' />
        <Input
          value={productInformation}
          onChange={e => setProductInformation(e.target.value)}
          caption='Produkt'
          placeholder='z.B. eine App für den Verkauf von nachhaltiger Kleidung'
        />
        <ButtonGroup>
          <ThemeButton onClick={handleNextClicked} iconRight={<FiChevronRight />} disabled={!productInformation}>
            Nächster Schritt
          </ThemeButton>
        </ButtonGroup>
      </Card>
    </Container>
  );
};

const Container = styled(ThemeContainer)`
  gap: ${theme.spacing.l};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  margin: 120px auto;

  @media screen and (max-width: ${theme.responsive.breakpoints.medium}) {
    margin: ${theme.spacing.xl} auto;
    padding: 0 ${theme.spacing.d};
    box-sizing: border-box;
  }
`;

const Card = styled(ThemeCard)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.s};
  padding: ${theme.spacing.xxl} ${theme.spacing.xl};
  width: 100%;

  @media screen and (max-width: ${theme.responsive.breakpoints.medium}) {
    padding: ${theme.spacing.xl} ${theme.spacing.d};
    padding-bottom: ${theme.spacing.d};
  }
`;

const Input = styled(ThemeInput)`
  margin-top: ${theme.spacing.xl};
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${theme.spacing.s};
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  margin-top: 150px;
`;
